// © Microsoft Corporation. All rights reserved.
/**
 * The audience mode enum
 */
export var AudienceModeType;
(function (AudienceModeType) {
    AudienceModeType["Adult"] = "adult";
    AudienceModeType["Enterprise"] = "enterprise";
    AudienceModeType["Kids"] = "kids";
})(AudienceModeType || (AudienceModeType = {}));
//# sourceMappingURL=AudienceModeType.js.map